import { Client } from '@connectrpc/connect';

import { LoginInboxService } from './espb/login_inbox_service_pb';
import { requireFieldNotEmpty } from './grpcUtils';
import { VaultId, GenerationId, VaultMessageTypeKnownValue } from './types';

export default class LoginInboxServiceClient {
  constructor(private readonly espbClient: Client<typeof LoginInboxService>) {}

  async show(
    slug: string,
    asOwner?: boolean,
  ): Promise<{
    vaultId: VaultId;
    generationId: GenerationId;
    publicKey: Uint8Array;
    metadataJson: string;
    organizationData?: {
      name: string;
      icon: string | undefined;
    };
    url: string;
    baseUrl: string;
  }> {
    const resp = await this.espbClient.show({ slug, asOwner });

    let organizationData: { name: string; icon: string | undefined } | undefined;
    const orgDataGrpc = resp.organizationData;
    if (orgDataGrpc) {
      organizationData = {
        name: requireFieldNotEmpty(orgDataGrpc.name),
        icon: orgDataGrpc.icon ?? undefined,
      };
    }

    return {
      vaultId: requireFieldNotEmpty(resp.vaultId),
      generationId: requireFieldNotEmpty(resp.generationId),
      publicKey: resp.publicKey,
      metadataJson: requireFieldNotEmpty(resp.metadata),
      organizationData,
      url: requireFieldNotEmpty(resp.url),
      baseUrl: requireFieldNotEmpty(resp.baseUrl),
    };
  }

  async createMessage(
    vaultId: VaultId,
    generationId: GenerationId,
    type: VaultMessageTypeKnownValue,
    encryptedData: Uint8Array,
  ) {
    await this.espbClient.createMessage({ vaultId, generationId, type, encryptedData });
  }
}
